var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('h1',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.title))]),_c('div',{class:_vm.$style.language},[_c('localization-controller',{attrs:{"language":_vm.language}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }